import Cookies from 'js-cookie'

// Save the campaign entry point if relevant
if (window.location.pathname.startsWith('/campaign/')) {
	const currentUrl = window.location.href;
	Cookies.set('entry_campaign', currentUrl, { expires: 30, path: '/' });
}

// Interfere with any outbound clicks
document.body.addEventListener('click', (event) => {
	// Only relevant links
	const link = event.target.closest('a[href]');
	if (!link) return;

	try {
		const url = new URL(link.href);

		if (url.hostname !== window.location.hostname && url.searchParams.has('utm_campaign')) {
			// Only if a campaign entry is present
			const entryCampaign = Cookies.get('entry_campaign');

			if (entryCampaign) {
				const currentCampaign = url.searchParams.get('utm_campaign');
				url.searchParams.set('utm_campaign', `${currentCampaign}_${encodeURIComponent(entryCampaign)}`);
				link.href = url.toString();
			}
		}
	} catch (error) {}
});
